const docMasks = {
  cnpj: "99.999.999/9999-99",
  cpf: "999.999.999-99",
};

export default docMasks;
